import React from 'react'
import { useAppDispatch, useAppSelector } from '@/lib/hooks/use-redux'
import { openModal } from '@/lib/redux'

export const useScannerToCart = () => {
  const dispatch = useAppDispatch()
  const { product } = useAppSelector((state) => state.selectedProduct)

  React.useEffect(() => {
    if (product) {
      dispatch(openModal('ADD_TO_CART'))
    }
  }, [product, dispatch])

  return {
    addToCart: () => {},
  }
}
